import { Filters, TextField } from '@shopify/polaris';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';

export default function DataTableFilters({
    productFilter,
    setProductFilter,
    vendorStyleFilter,
    setVendorStyleFilter,
    skuFilter,
    setSkuFilter,
    barcodeFilter,
    setBarcodeFilter,
    qtyExpectedFilter,
    setQtyExpectedFilter,
    qtyReceivedToDateFilter,
    setQtyReceivedToDateFilter,
    qtyReceivedFilter,
    setQtyReceivedFilter,
    queryValue,
    setQueryValue,
}) {
    return (
        <Filters
            queryValue={queryValue}
            onQueryChange={setQueryValue}
            onQueryClear={() => setQueryValue('')}
            filters={[
                {
                    key: 'product',
                    label: `${PURCHASE_ORDER_STRINGS.PRODUCT}`,
                    filter: <TextField label="Product" value={productFilter} onChange={setProductFilter} autoComplete="off" />,
                },
                {
                    key: 'vendorStyle',
                    label: `${PURCHASE_ORDER_STRINGS.VENDOR_STYLE}`,
                    filter: <TextField label="Vendor Style" value={vendorStyleFilter} onChange={setVendorStyleFilter} autoComplete="off" />,
                },
                {
                    key: 'sku',
                    label: `${PURCHASE_ORDER_STRINGS.SKU}`,
                    filter: <TextField label="SKU" value={skuFilter} onChange={setSkuFilter} autoComplete="off" />,
                },
                {
                    key: 'barcode',
                    label: `${PURCHASE_ORDER_STRINGS.UPC}`,
                    filter: <TextField label="UPC" value={barcodeFilter} onChange={setBarcodeFilter} autoComplete="off" />,
                },
                {
                    key: 'qtyExpected',
                    label: `${PURCHASE_ORDER_STRINGS.QTY_EXPECTED}`,
                    filter: <TextField label="QTY Expected" value={qtyExpectedFilter} onChange={setQtyExpectedFilter} autoComplete="off" />,
                },
                {
                    key: 'qtyReceivedToDate',
                    label: `${PURCHASE_ORDER_STRINGS.QTY_RECEIVED_TO_DATE}`,
                    filter: <TextField label="QTY Received to Date" value={qtyReceivedToDateFilter} onChange={setQtyReceivedToDateFilter} autoComplete="off" />,
                },
                {
                    key: 'qtyReceived',
                    label: `${PURCHASE_ORDER_STRINGS.QTY_RECEIVED}`,
                    filter: <TextField label="QTY Received" value={qtyReceivedFilter} onChange={setQtyReceivedFilter} autoComplete="off" />,
                },
            ]}
            appliedFilters={[
                ...(productFilter
                    ? [
                          {
                              key: 'product',
                              label: `${PURCHASE_ORDER_STRINGS.PRODUCT}: ${productFilter}`,
                              onRemove: () => setProductFilter(''),
                          },
                      ]
                    : []),
                ...(vendorStyleFilter
                    ? [
                          {
                              key: 'vendorStyle',
                              label: `${PURCHASE_ORDER_STRINGS.VENDOR_STYLE}: ${vendorStyleFilter}`,
                              onRemove: () => setVendorStyleFilter(''),
                          },
                      ]
                    : []),
                ...(skuFilter
                    ? [
                          {
                              key: 'sku',
                              label: `${PURCHASE_ORDER_STRINGS.SKU}: ${skuFilter}`,
                              onRemove: () => setSkuFilter(''),
                          },
                      ]
                    : []),
                ...(barcodeFilter
                    ? [
                          {
                              key: 'barcode',
                              label: `${PURCHASE_ORDER_STRINGS.UPC}: ${barcodeFilter}`,
                              onRemove: () => setBarcodeFilter(''),
                          },
                      ]
                    : []),
                ...(qtyExpectedFilter
                    ? [
                          {
                              key: 'qtyExpected',
                              label: `${PURCHASE_ORDER_STRINGS.QTY_EXPECTED}: ${qtyExpectedFilter}`,
                              onRemove: () => setQtyExpectedFilter(''),
                          },
                      ]
                    : []),
                ...(qtyReceivedToDateFilter
                    ? [
                          {
                              key: 'qtyReceivedToDate',
                              label: `${PURCHASE_ORDER_STRINGS.QTY_RECEIVED_TO_DATE}: ${qtyReceivedToDateFilter}`,
                              onRemove: () => setQtyReceivedToDateFilter(''),
                          },
                      ]
                    : []),
                ...(qtyReceivedFilter
                    ? [
                          {
                              key: 'qtyReceived',
                              label: `${PURCHASE_ORDER_STRINGS.QTY_RECEIVED}: ${qtyReceivedFilter}`,
                              onRemove: () => setQtyReceivedFilter(''),
                          },
                      ]
                    : []),
            ]}
            onClearAll={() => {
                setQueryValue('');
                setProductFilter('');
                setVendorStyleFilter('');
                setSkuFilter('');
                setBarcodeFilter('');
                setQtyExpectedFilter('');
                setQtyReceivedToDateFilter('');
                setQtyReceivedFilter('');
            }}
        />
    );
}
